import { extend } from 'flarum/common/extend';
import DiscussionHero from 'flarum/forum/components/DiscussionHero';
import EngineVersion from '../common/models/EngineVersion';

function engineVersionLabel(version: EngineVersion | null | undefined, attrs: any = {}) {
  if (!version) {
    return null;
  }

  const color = version.color();
  const className = 'EngineVersionLabel ' + (attrs.className || '');

  return m(
    'span',
    {
      className: className,
      style: {
        backgroundColor: color,
        '--engine-version-color': color,
      },
    },
    version.name()
  );
}

export default function addEngineVersionLabels() {
  // Add engine version to discussion hero (detail page)
  extend(DiscussionHero.prototype, 'items', function (items) {
    const discussion = this.attrs.discussion;

    // 安全检查：确保 engineVersion 方法存在
    if (typeof discussion.engineVersion !== 'function') {
      return;
    }

    const engineVersion = discussion.engineVersion() as EngineVersion | null;

    if (engineVersion) {
      items.add(
        'engineVersion',
        engineVersionLabel(engineVersion, { className: 'EngineVersionLabel--hero' }),
        5
      );
    }
  });
}
